import { create } from 'zustand'

import {
  type CoreBookingDocument,
  type CoreBooking,
  type CoreUser,
} from '@flecto/types'

export type BookingStore = {
  reset: () => void
  user: CoreUser | null
  booking: CoreBooking | null
  documents: CoreBookingDocument[] | null
  setUser: (user: CoreUser | null) => void
  setBooking: (booking: CoreBooking | null) => void
  setDocuments: (documents: CoreBookingDocument[] | null) => void
}

export const useBookingStore = create<BookingStore>((set) => ({
  user: null,
  booking: null,
  documents: null,
  setUser: (user) => set({ user }),
  setBooking: (booking) => set({ booking }),
  setDocuments: (documents) => set({ documents }),
  reset: () =>
    set({
      booking: null,
      documents: null,
      user: null,
    }),
}))
